import React from 'react';
import ClickableOpacity from '../ClickableOpacity';
import XIcon from '../../icons/utility/XIcon';
export const XButton = ({ size = 'utility', ...rest }) => (React.createElement(ClickableOpacity, { ...rest },
    React.createElement(XIcon, { size: size })));
export default XButton;
//# sourceMappingURL=index.js.map